import State from '@/store/state';
import { ReportValidationError } from '@/store/types';

export const get = (state: State['reportValidation']): ReportValidationError[] => state;
export const hasError = (state: State['reportValidation']): boolean => state.length > 0;
